document.addEventListener( 'DOMContentLoaded', function() {
    var splide2 = new Splide( '#splide_news', {
        type   : 'slide',
        padding: '1rem',
        gap: 15,
        perPage: 3,
        arrows: false,
        pagination: true,
        rewind: true,
        autoplay: true,
        interval: 5000,
        pauseOnHover: true,
        pauseOnFocus: true,
        breakpoints: {
            768: {
                perPage: 2,
            },
            465: {
                perPage: 1,
            },
        }
    });
    splide2.mount();
});
